import Head from 'next/head'
import { fetchGetAdsByCompany, fetchGetBanners } from '../../../services/api'
import ContactUsContactForm from '../../components/contact-us/contact-form'
import ContactUsMapArea from '../../components/contact-us/map-area'
import SingleBanner from '../../components/default/single-banner'
import HomeLastOffers from '../../components/home/last-offers'
import Footer from '../../components/layout/footer'
import Header from '../../components/layout/header'

export default function ContactPage({ companyGeneralData, banner, adsLastOffers }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`${companyGeneralData.company.nickName} Revenda melhores preços de veículos, ofertas de carros nacionais e importados. Confira nossas ofertas.`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${(companyGeneralData.company.nickName).toUpperCase()} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - Fale Conosco`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <ContactUsContactForm company={companyGeneralData.company} />
                <ContactUsMapArea company={companyGeneralData.company} />
                <HomeLastOffers ads={adsLastOffers} />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps({ query }) {
    const banners = await fetchGetBanners({ idMenuOption: 8 });
    const adsLastOffers = await fetchGetAdsByCompany({
        pagination: { pageSize: 8, page: query.pag ?? 0 },
        filters: {},
        orderBy: 'LAST_VEHICLES'
    });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null,
            adsLastOffers
        }
    }
}